<template>
    <div>
        <h2 class="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
            {{ $t('auth.twoFactorSetup.pageTitle') }}
        </h2>

        <p class="mt-6 flex flex-col items-center justify-between text-sm leading-5">
            {{ $t('auth.twoFactorSetup.instructions') }}
        </p>

        <apexo-button class="mt-6" @click="enableTwoFactorAuthentication">
            {{ $t('auth.twoFactorSetup.activate') }}
        </apexo-button>

        <two-factor-setup-modal @closed="goToSetPassword" />
    </div>
</template>

<script>
    import TwoFactorSetupModal from '@/components/Auth/TwoFactorSetupModal.vue';
    import ApexoButton from '../../components/Elements/ApexoButton.vue';

    export default {
        components: { TwoFactorSetupModal, ApexoButton },

        methods: {
            async enableTwoFactorAuthentication() {
                try {
                    await this.$axios.post('/user/two-factor-authentication');

                    const qrCodeResponse = await this.$axios.get('/user/two-factor-qr-code');
                    const recoveryCodesResponse = await this.$axios.get('/user/two-factor-recovery-codes');

                    this.$modal.open('two-factor-setup', {
                        qrCode: qrCodeResponse.data.svg,
                        recoveryCodes: recoveryCodesResponse.data,
                    });
                } catch (error) {
                    console.log(error);
                    this.$axios.delete('/user/two-factor-authentication');
                }
            },

            goToSetPassword() {
                this.$router.replace({ name: 'auth.set-password' });
            },
        },
    };
</script>
